import { ChallengeSettings } from '@/model/ChallengeSettings.model';
import { Question } from '@/model/Question.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from "rxjs/internal/Observable";
import { Subject } from 'rxjs/internal/Subject';
import AjaxService from './ajax.service';
import { baseUrl, storage } from "../config/firebase";
import firebase from 'firebase';
import LayoutService from "./layout.service";
class ChallengeService extends AjaxService {
  public questionSub = new BehaviorSubject<Question>({
    name: "",
    answers: [],
    image: "",
    maxWords: 0,
    secondsToAnswer: 0,
    index: 0,
    correctAnswer: ""
  });
  public getQuestion = this.questionSub.asObservable();
  public progressSubscriber = new Subject<any>();
  public storage = firebase.storage();
  createChallenge(data: any, currentUser: any) {
    LayoutService.setLoading(true);
    return new Observable(sub => {
      data.creator = currentUser;
      this.post(`${baseUrl}/createChallenge`, data).subscribe((result) => {
        sub.next(result);
        sub.complete();
        LayoutService.setLoading(false);
      })
    })
  }

  removeChallenge(id: any) {
    const data = {
      challengeId: id
    };
    return this.post(`${baseUrl}/remove`, data).subscribe(result => {
      console.log(result);
    })
  }

  updateChallenge(challengeId: string, dataUpdate: any) {
    return new Observable(sub => {
      const data = {
        challengeId,
        dataUpdate
      };
      this.post(`${baseUrl}/updateChallenge`, data).subscribe((result) => {
        sub.next(result);
        sub.complete();
      })
    })
  }

  uploadImages(files: any, fileName: string) {
    return new Observable(sub => {
      const storageRef = storage.ref();
      const avatarRef = storageRef.child(`photos-${fileName}`);
      avatarRef.put(files).then(result => {
        avatarRef.getDownloadURL().then(url => {
          sub.next(url);
        })
      })
    })
  }

  setQuestion(question: Question, index: any) {
    question.index = index;
    this.questionSub.next(question);
  }
  getChallengesSettings(): Observable<ChallengeSettings[]> {
    return new Observable(subscriber => {
      subscriber.next(this.dataChallengesSettings());
      subscriber.complete();
    });
  }

  dataChallengesSettings(): ChallengeSettings[] {
    return this.challenges.map(challenge => {
      const settings: any[] = this.getListSettings(challenge.id);
      const challengeSettings: ChallengeSettings = {
        ...challenge,
        settings
      };
      return challengeSettings;
    })
  }

  getListSettings(challengeId: number): any[] {
    const settings = this.mapping.filter(s => s.challengeId === challengeId);
    return settings.map(s => {
      const setting = this.settings.find(setting => setting.id === s.settingId);
      return {
        id: s.settingId,
        challengeId: s.challengeId,
        ...setting
      };
    });
  }


  mapping = [
    { challengeId: 1, settingId: 2 },
    { challengeId: 2, settingId: 2 },
    { challengeId: 3, settingId: 2 },
    { challengeId: 4, settingId: 2 },
    { challengeId: 4, settingId: 1 }
  ];

  settings = [
    {
      id: 1,
      name: "Topics",
      description: "",
      data: {
        topics: []
      }
    },
    {
      id: 2,
      name: "Timer",
      description: "",
      data: {
        secondQuestion: "auto",
        totalTime: 10
      }
    }
  ];

  challenges = [
    {
      id: 1,
      name: "Quiz",
      description: "Get players to choose the only correct answers from the choice options",
      challengeName: "",
      challengeDescription: "",
      questions: [],
      imageChallenge: "",
      icon: "assignment_turned_in"
    },
    // {
    //   id: 2,
    //   name: "Poll",
    //   description: "Get players to choose from up to 8 choice options",
    //   challengeName: "",
    //   challengeDescription: "",
    //   questions: [],
    //   imageChallenge: "",
    //   icon: "assessment"
    // },
    // {
    //   id: 3,
    //   name: "Open-ended",
    //   description: "Ask players to type a limited word counting response",
    //   challengeName: "",
    //   challengeDescription: "",
    //   questions: [],
    //   imageChallenge: "",
    //   icon: "forum"
    // },
    {
      id: 4,
      name: "Random",
      description: "Auto-generated quiz questions for you to choose from",
      challengeName: "",
      challengeDescription: "",
      questions: [],
      imageChallenge: "",
      icon: "casino"
    }
  ];
}

export default new ChallengeService();
